"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TARIFF_FIELD_META = void 0;
var TARIFF_FIELD_META = [
    { key: "energyCharges", label: "Energy Charges", group: "Charges" },
    { key: "demandCharges", label: "Demand Charges", group: "Charges" },
    { key: "fixedCharges", label: "Fixed Charges", group: "Charges" },
    { key: "effectiveFrom", label: "Effective From", group: "Validity" },
    { key: "effectiveTo", label: "Effective To", group: "Validity" },
    { key: "isActive", label: "Active", group: "Status" },
    { key: "notes", label: "Notes", group: "Other" },
];
exports.TARIFF_FIELD_META = TARIFF_FIELD_META;
